import React from 'react';
import { Box } from '@mui/material';
import ResourceManagement from '../components/ResourceManagement';
import { useParams } from 'react-router-dom';

function Resources() {
  const { projectId } = useParams();

  return (
    <Box>
      <ResourceManagement projectId={projectId} />
    </Box>
  );
}

export default Resources;
